module.exports = __webpack_public_path__ + "img/clients-03.587d6030.svg";